import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { fetchFullDetails } from 'web-interactives-dashboard-ui/actions/DetailsActions';
import { MODAL_TYPES } from 'web-interactives-dashboard-ui/constants/ModalConstants';
import withModalProps from 'web-interactives-dashboard-ui/hoc/withModalProps';
import useRequestState from 'web-interactives-dashboard-ui/hooks/useRequestState';
import { getEditUrl } from 'web-interactives-dashboard-ui/utils/urls';
import { FETCH_DETAILS_REQUEST } from 'web-interactives-dashboard-ui/utils/requestStateKeys';
import DetailsPanelContent from './DetailsPanelContent';
import DetailsActionsMenu from '../details/DetailsActionsMenu';
import { getInteractiveDisplayData } from '../../selectors/details';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Text } from 'foundations-components/components/Text';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import useIsSmartCta from '../../hooks/useIsSmartCta';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DetailsPanel = ({
  interactiveId,
  objectId,
  onClose
}) => {
  const dispatch = useDispatch();
  const {
    isError,
    isLoading,
    hasSucceeded
  } = useRequestState([FETCH_DETAILS_REQUEST]);
  useEffect(() => {
    dispatch(fetchFullDetails(interactiveId));
  }, [dispatch, interactiveId]);
  const interactiveData = useSelector(getInteractiveDisplayData);
  const isSmart = useIsSmartCta(String(interactiveId)).isSmartCta;
  return /*#__PURE__*/_jsxs(Panel, {
    "data-test-id": "details-panel",
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        color: "fill-surface-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "details.panel.title"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsxs(PanelSection, {
        children: [isLoading && /*#__PURE__*/_jsx(LoadingOverlay, {
          contextual: true
        }), isError && /*#__PURE__*/_jsx(ErrorMessage, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "details.panel.error.title"
          }),
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "details.panel.error.description"
            })
          })
        }), hasSucceeded && /*#__PURE__*/_jsx(DetailsPanelContent, {})]
      })
    }), /*#__PURE__*/_jsxs(PanelFooter, {
      children: [/*#__PURE__*/_jsx(DetailsActionsMenu, {
        buttonProps: {
          disabled: !(hasSucceeded && interactiveData)
        },
        interactiveData: interactiveData && Object.assign({}, interactiveData, {
          contentId: interactiveData.id,
          objectId,
          state: interactiveData.status,
          isActiveAbTest: interactiveData.isActiveAbTest,
          isPersonalized: interactiveData.isPersonalized,
          isSmart
        })
      }), /*#__PURE__*/_jsx(Button, {
        href: getEditUrl(interactiveId),
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "actionMenu.edit"
        })
      })]
    })]
  });
};
export default withModalProps(DetailsPanel, MODAL_TYPES.DETAILS_PANEL);